<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Registrar riego
            <router-link :to="{ name: 'Riego', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  :value.sync="$v.form.fechahora.$model"
                  :isValid="checkIfValidForm('fechahora')"
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación:</label>
                <v-select
                  v-model="form.ubicacion_id"
                  :options="ubicaciones"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  placeholder="Selecciona una trabajador"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="3" lg="3">
                <CInput
                  v-model="form.entrada_lt"
                  :isValid="checkIfValidForm('entrada_lt')"
                  invalidFeedback="Campo requerido"
                  :label="`Entrada lt: `"
                  type="number"
                />
              </CCol>
              <CCol sm="12" md="3" lg="3">
                <CInput
                  v-model="form.salida_lt"
                  :isValid="checkIfValidForm('salida_lt')"
                  invalidFeedback="Campo requerido"
                  :label="`Salida lt: `"
                  type="number"
                />
              </CCol>
              <CCol sm="12" md="3" lg="3">
                <CInput
                  disabled
                  :value="$formatter((form.salida_lt / form.entrada_lt) * 100)"
                  :label="`Drenado %: `"
                  type="number"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CRow>
                  <CCol sm="12" md="6" lg="6">
                    <CInput
                      v-model="form.entrada_ph"
                      :isValid="checkIfValidForm('entrada_ph')"
                      invalidFeedback="Campo requerido"
                      :label="`Entrada pH: `"
                      type="number"
                    />
                  </CCol>
                  <CCol sm="12" md="6" lg="6">
                    <CInput
                      v-model="form.salida_ph"
                      :isValid="checkIfValidForm('salida_ph')"
                      invalidFeedback="Campo requerido"
                      :label="`Salida pH: `"
                      type="number"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CRow>
                  <CCol sm="12" md="6" lg="6">
                    <CInput
                      v-model="form.entrada_ce"
                      :isValid="checkIfValidForm('entrada_ce')"
                      invalidFeedback="Campo requerido"
                      :label="`Entrada ce: `"
                      type="number"
                    />
                  </CCol>
                  <CCol sm="12" md="6" lg="6">
                    <CInput
                      v-model="form.salida_ce"
                      :isValid="checkIfValidForm('salida_ce')"
                      invalidFeedback="Campo requerido"
                      :label="`Salida ce: `"
                      type="number"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CTextarea
                  :value.sync="comentarios"
                  :label="`Comentarios: `"
                  placeholder="Comentarios..."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="
                    () => {
                      fetching = false;
                    }
                  "
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Labor', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton
              v-else
              @click="addLabor()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="successModal = false" color="success"
            >Aceptar</CButton
          >
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "NuevoLabor",

  components: {
    vSelect
  },

  data() {
    return {
      date: null,
      multi: null,
      config: this.$route.params.config,
      // categoria: null,
      form: {},
      ubicacion: null,
      ubicaciones: [],
      ubicacionesAll: [],
      tiempo_extra: false,
      isFijo: false,
      isLoading: false,
      isLoadingPage: false,
      unidad: "kg",
      unidadPagar: "dia",
      warningModal: false,
      successModal: false,
      error: "",
      configurationToggle: true,
      comentarios: "",
      fetching: false,
      medias: []
    };
  },

  mixins: [validationMixin],
  validations: {
    form: {
      ubicacion_id: {
        required
      },
      entrada_lt: {
        required
      },
      salida_lt: {
        required
      },
      entrada_ph: {
        required
      },
      salida_ph: {
        required
      },
      entrada_ce: {
        required
      },
      salida_ce: {
        required
      },
      fechahora: {
        required
      }
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.form.fechahora.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;

    // call configuration toggle for tiempo extrea
    this.$store
      .dispatch("customHTTP", {
        schema: "configuracion",
        filter: {
          where: [
            {
              field: "payload->parametro",
              value: "modo_calculo_horas_extras",
              operator: "="
            }
          ]
        }
      })
      .then(response => {
        this.configurationToggle =
          response.data[0].payload.valor === "auto" ? false : true;
      })
      .catch(error => {
        console.error(error);
      });

    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    // const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
    //   schema: "ubicaciones"
    // });

    const ubi = [];

    if (this.ubicacionRaizValue) {
      ubi.push(ubicacionTemplateRaiz);
    } else {
      ubi.push(Promise.resolve({ data: [] }));
    }

    Promise.all(ubi)
      .then(([ubicaciones]) => {
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });

        this.ubicacionesAll = ubicaciones.data;
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async m => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      // const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      //   schema: "ubicaciones"
      // });
      this.isLoadingPage = true;
      this.$store;

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(Promise.resolve({ data: [] }));
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    tiempoExtra() {
      this.tiempo_extra = !this.tiempo_extra;
    },
    filtrarUbicacion() {
      console.log("cambio");
    },
    async addLabor() {
      debugger;

      this.validateLabor();

      this.fetching = true;
      this.isLoading = true;
      await new Promise((res, ) => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            clearInterval(iter);
            res();
          }
          debugger;
        }, 1000);
      });
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }
      if (this.isValidDate) {
        if (!this.validateUbicacion()) {
          this.error = "El campo ubicaciones es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        let newDate = moment(this.form.fechahora, "YYYY-MM-DD HH:mm:ss");

        const labor = this.$store.dispatch("customDocumentoAddHTTP", {
          schema: "riego",
          payload: {
            encabezado: {
              fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
              ubicacion_id: this.form.ubicacion_id.value,
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
              entrada_lt: Number(this.form.entrada_lt),
              entrada_ph: Number(this.form.entrada_ph),
              entrada_ce: Number(this.form.entrada_ce),
              salida_lt: Number(this.form.salida_lt),
              salida_ph: Number(this.form.salida_ph),
              salida_ce: Number(this.form.salida_ce),
              comentarios: this.comentarios || ""
            },
            anexos: this.medias
          }
        });

        labor
          .catch(rej => {
            console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.isLoading = false;
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
      }
    },
    validateUbicacion() {
      return !this.$v.form.fechahora.$invalid;
    },
    checkIfValidForm(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      console.log(field);
      debugger;
      return !(field.$invalid || field.$model === "");
    },
    validateLabor() {
      this.$v.form.$touch();
    },
    cleanMulti() {
      this.multi = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
